<template>
    <div class="homeContent" v-if="account">
        
        <div style="background-color: #fff; width: 100%; padding-left: 20px; padding-right: 20px;">
            <v-row align="center" justify="space-between">
                <v-col cols="auto">
                    <h6>Hourly Production Logbooks</h6>
                </v-col>
                <v-col cols="auto" style="padding-bottom: 0px!important;" class="mobileNav">
                    <div class="mobileView" style="display: flex; gap: 20px; align-items: center;">
                        <v-text-field class="mobileInputs" label="Search" prepend-inner-icon="mdi-magnify" variant="solo"
                            style="width: 180px;" v-model="search"></v-text-field>
                        <v-select class="mobileInputs"  label="DS1" :items="['DS1', 'DS2']" variant="solo" style="width: 100px;" disabled></v-select>
                        <v-btn class="mobileInputs"  prepend-icon="mdi-plus" style="height: 56px; margin-bottom: 22px;" color="#1e2ec6"
                            @click="goTo()">New logbook</v-btn>

                    </div>
                </v-col>
            </v-row>
        </div>

        <div class="mt-4">
            <v-row v-if="loadingLogbooks">
                <v-col v-for="i in 12" :key="i" cols="12" sm="4">
                    <div>
                        <div class="mb-4">
                            <v-skeleton-loader type="image, image"></v-skeleton-loader>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col cols="12" sm="4" v-for="logbook in filteredProducts(logbooks)" :key="logbook">
                    
                    <v-card class="mx-auto logbookCard" @click="goToDetail(logbook.id)">
                        <v-img gradient="to top right, rgba(0,0,0,.11), rgba(0,0,0,.3)" :src="require('../../assets/nvbackground.jpg')" class="align-end text-white" height="200" cover></v-img>
                        <v-card-text>
                            <v-row>
                                <v-col cols="9"><span style="font-weight: bold;">{{ logbook.name }}</span></v-col>
                                <v-spacer></v-spacer>
                                <v-col style="text-align: end;">
                                    <v-icon icon="mdi-chevron-right"></v-icon>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {

            account: undefined,
            accountName: "",
            selectedDate: null,
            logbooks: [],
            selectedLogbook: null,
            currentShift: [],
            isLoadingLineFact: false,
            loadingLogbooks: false,
            search: "",
        };
    },
    async mounted() {
        const msalApp = window.msalApp;
        this.account = msalApp.getActiveAccount();
        if (this.account) {
            this.accountName = this.account.name;
            this.accountEmail = this.account.username;
        }
        await this.getLogbooks();
    },
    methods: {


        /**
         * Filters the products based on the search query.
         *
         * @param {Array} stx - The array of products to filter.
         * @returns {Array} - The filtered array of products whose names contain the search query.
         */
        filteredProducts(stx) {
            return stx.filter(s => {
                return s.name.toLowerCase().indexOf(this.search.toLowerCase()) != -1;
            });
        },
        /**
         * Navigates the user to the logbooks configuration page.
         * This method uses Vue Router to push a new route onto the router's history stack.
         */
        goTo() {
            this.$router.push('/logbooks-config')
        },
        /**
         * Navigates to the detail view of a specific item.
         * 
         * @param {string} id - The unique identifier of the item to view in detail.
         */
        goToDetail(id) {
            this.$router.push('/logbook/' + id)
        },
        /**
         * Fetches the logbooks for the user.
         * 
         * This method sets the `loadingLogbooks` flag to true, makes an asynchronous GET request to the 
         * "/apiv1/my-logbooks" endpoint, and processes the response. If the request is successful, the 
         * logbooks data is stored in the `logbooks` property. If the request fails, an error is logged 
         * to the console. Regardless of the outcome, the `loadingLogbooks` flag is set to false after 
         * the request completes.
         * 
         * @returns {Promise<void>} A promise that resolves when the logbooks have been fetched and processed.
         */
        async getLogbooks() {
            this.loadingLogbooks = true;
            await axios.get("/apiv1/my-logbooks-flat").then(res => {
                console.log(res);
                this.logbooks = res.data
            }).catch(err => {
                console.log(err);
                this.loadingLogbooks = false;
                // TO DO: Handle error response with a snackbar
            });
            this.loadingLogbooks = false;
        },
    },
    components: {
    }
}
</script>

<style scoped>
.homeContent {
    padding-left: 20px;
    padding-right: 20px;
}

.logBookContent {
    background-color: #fff;
    padding: 40px;
    margin-bottom: 20px;
    border-radius: 4px;
    box-shadow: 0px 0px 20px -15px;
}

.navigateButtons {
    height: 55px;
}

.logbookCard {
    transition: all 0.2s;
}

.logbookCard:hover {
    cursor: pointer;
    transform: scale(1.02);
    background-color: rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
    .mobileView {
        display: block!important;
    }
    .mobileNav{
        width: 100%!important;
    }
    .mobileInputs{
        width: 100%!important;
    }
}
</style>
